import fetcher_v2 from "@/api/fetcher_v2";
import { URLS } from "@/api/urls";
import { Plan } from "@/types/Plan";

type StripeCheckoutSessionResponse = { url: string };

export const getPlans = () => {
  return fetcher_v2<Plan[]>(URLS.PLAN_LIST, {
    method: "GET",
  });
};

export const getGrowthPlans = () => {
  return fetcher_v2<Plan[]>(URLS.GROWTH_PLAN_LIST, {
    method: "GET",
  });
};

export const createStripeCheckoutSession = (
  default_price: string,
  plan_uuid: Uuid,
  is_growth = false
) =>
  fetcher_v2<StripeCheckoutSessionResponse>(URLS.CREATE_CHECKOUT_SESSION, {
    method: "POST",
    body: {
      default_price: default_price,
      plan_uuid: plan_uuid,
      is_growth: is_growth,
    },
  });
